// eslint-disable-next-line import/no-unresolved
import Swiper from 'swiper/bundle';

/* eslint-disable max-len */
class FitAssistant extends HTMLElement {
  constructor() {
    super();
    this.introContainer = this.querySelector('.intro-container');
    this.getStartedButton = this.introContainer.querySelector('.button');
    this.fitAssistantDrawer = this.querySelector('.fit-assistant-drawer');
    this.swiperFirstButton = this.querySelector('.swiper-slide--first');
    this.getYourSizeLink = this.querySelector('.swiper-slide--last');
    this.swiperContainer = this.querySelector('#swiper-fit-assistant');
    this.swiperPrevButtons = this.querySelectorAll('.swiper-slide--prev');
    this.swiperNextButtons = this.querySelectorAll('.swiper-slide--next');
    this.resultContainer = this.querySelector('.result-container');
    this.regularIcon = this.querySelector('.icon-width--regular');
    this.narrowIcon = this.querySelector('.icon-width--narrow');
    this.size = this.querySelector('#size');
    this.fit = this.querySelector('#fit');
    this.startAgainLink = this.querySelector('.link-start-again');
    this.modalCloseButton = this.querySelector('.button--modal-close');
    this.openTipLinks = this.querySelectorAll('.measuring-tips');
    this.closeTipLinks = this.querySelectorAll('.close-tips');
    this.fitAssistantContainer = this.querySelector('.fit-assistant-drawer--container');
    this.measuringTipContainer = this.querySelector('.measuring-tips--container');
    this.helpInfo = this.querySelector('.help-label-info');
    this.sizeAssistantLinks = document.querySelectorAll('.link--size-assistant');
    this.continueShoppingLinks = document.querySelectorAll('.link--continue-shopping');
    this.playVideo = this.querySelector('.play-video');
    this.videoCloseButton = this.querySelector('.button--close-video');
    this.sizingErrorMessage = this.querySelector('.sizing-error--message');
    this.swiper = new Swiper('#swiper-fit-assistant', JSON.parse(this.swiperContainer.getAttribute('data-slider-settings')));

    if (this.getStartedButton) {
      this.getStartedButton.addEventListener('click', this.getStarted.bind(this));
    }
    if (this.swiperFirstButton) {
      this.swiperFirstButton.addEventListener('click', this.showIntro.bind(this));
    }
    if (this.startAgainLink) {
      this.startAgainLink.addEventListener('click', this.startAgain.bind(this));
    }
    if (this.getYourSizeLink) {
      this.getYourSizeLink.addEventListener('click', this.getYourSize.bind(this));
    }
    if (this.modalCloseButton) {
      this.modalCloseButton.addEventListener('click', this.closeFitAssistantDrawer.bind(this));
    }
    if (this.swiperPrevButtons) {
      this.swiperPrevButtons.forEach((button) => button.addEventListener('click', this.scrollToPrevSlide.bind(this)));
    }
    if (this.swiperNextButtons) {
      this.swiperNextButtons.forEach((button) => button.addEventListener('click', this.scrollToNextSlide.bind(this)));
    }
    if (this.openTipLinks) {
      this.openTipLinks.forEach((link) => link.addEventListener('click', this.openMeasuringTips.bind(this)));
    }
    if (this.closeTipLinks) {
      this.closeTipLinks.forEach((link) => link.addEventListener('click', this.closeMeasuringTips.bind(this)));
    }
    if (this.helpInfo) {
      this.helpInfo.addEventListener('click', this.openMeasuringTips.bind(this));
    }
    if (this.sizeAssistantLinks) {
      this.sizeAssistantLinks.forEach((link) => link.addEventListener('click', this.openFitAssistantDrawer.bind(this)));
    }
    if (this.playVideo) {
      this.playVideo.addEventListener('click', this.playFittingVideo.bind(this));
    }
    if (this.videoCloseButton) {
      this.videoCloseButton.addEventListener('click', this.closeFittingVideo.bind(this));
    }
    if (this.continueShoppingLinks) {
      this.continueShoppingLinks.forEach((link) => link.addEventListener('click', this.closeFitAssistantDrawer.bind(this)));
    }
    this.fitAssistantObserver();

    if (window.location.href.includes('size-assistant')) {
      this.openFitAssistantDrawer();
    }
  }

  fitAssistantObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          this.swiper = this.querySelector('#swiper-fit-assistant').swiper;
          observer.disconnect();
        }
      });
    });

    observer.observe(this.fitAssistantDrawer, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false,
    });
  }

  getStarted() {
    this.introContainer.style.display = 'none';
    this.swiperContainer.style.display = 'block';
  }

  startAgain() {
    this.introContainer.style.display = 'none';
    this.swiperContainer.style.display = 'block';
    this.resultContainer.style.display = 'none';
  }

  shopThisSize() {
    const size = this.size.textContent.split(' ')[0];
    const fit = this.fit.textContent.split(' ')[0];
    window.location.href = `${window.styleFinderCollection}#/filter:ss_filter_width:${fit}/filter:ss_instock_sizes:${size}`;
  }

  async getYourSize() {
    let inputValidated = true;
    const validationMessage = this.querySelector('.validation-message');
    const isAdult = this.querySelector('#size-radio-adult').checked;

    this.querySelectorAll('.input-container input[type="text"]')
      .forEach((element) => {
        const inputValue = Number(element.value);

        if (inputValue === 0) {
          inputValidated = false;
          validationMessage.textContent = window.inputValidationMessage;
          element.classList.add('error');
          element.focus();
        } else if (isAdult && element.classList.contains('foot-length') && (inputValue < 216 || inputValue > 322)) {
          inputValidated = false;
          validationMessage.textContent = window.adultFootLengthValidationMessage;
          element.classList.add('error');
          element.focus();
        } else if (isAdult && element.classList.contains('foot-width') && (inputValue < 81 || inputValue > 123)) {
          inputValidated = false;
          validationMessage.textContent = window.adultFootWidthValidationMessage;
          element.classList.add('error');
          element.focus();
        } else if (!isAdult && element.classList.contains('foot-length') && (inputValue < 144 || inputValue > 215)) {
          inputValidated = false;
          validationMessage.textContent = window.kidFootLengthValidationMessage;
          element.classList.add('error');
          element.focus();
        } else if (!isAdult && element.classList.contains('foot-width') && (inputValue < 59 || inputValue > 87)) {
          inputValidated = false;
          validationMessage.textContent = window.kidFootWidthValidationMessage;
          element.classList.add('error');
          element.focus();
        } else {
          element.classList.remove('error');
        }
      });

    if (inputValidated) {
      validationMessage.textContent = '';
      const leftFootWidth = Number(this.querySelector('#left-foot-width').value);
      const leftFootLength = Number(this.querySelector('#left-foot-length').value);
      const rightFootWidth = Number(this.querySelector('#right-foot-width').value);
      const rightFootLength = Number(this.querySelector('#right-foot-length').value);
      const fittingSize = await this.getFittingSize(leftFootWidth, leftFootLength, rightFootWidth, rightFootLength, isAdult);
      if (fittingSize != null) {
        this.size.textContent = `${fittingSize.size} EU`;
        this.fit.textContent = `${fittingSize.fit} Fit`;
        this.introContainer.style.display = 'none';
        this.swiperContainer.style.display = 'none';
        this.sizingErrorMessage.style.display = 'none';
        this.resultContainer.style.display = 'block';
        const shopThisSizeButtons = this.querySelectorAll('.button--shop-this-size');
        shopThisSizeButtons.forEach((button) => button.addEventListener('click', this.shopThisSize.bind(this)));
        if (fittingSize.fit === 'Regular') {
          this.regularIcon.style.display = 'block';
          this.narrowIcon.style.display = 'none';
        } else if (fittingSize.fit === 'Narrow') {
          this.regularIcon.style.display = 'none';
          this.narrowIcon.style.display = 'block';
        }
      } else {
        this.sizingErrorMessage.style.display = 'block';
      }
    }
  }

  showIntro() {
    this.introContainer.style.display = 'grid';
    this.swiperContainer.style.display = 'none';
    this.resultContainer.style.display = 'none';
  }

  scrollToNextSlide() {
    this.swiper.slideNext();
  }

  scrollToPrevSlide() {
    this.swiper.slidePrev();
  }

  async fetchFittingData() {
    let data = null;

    try {
      const response = await fetch(`${window.Shopify.routes.root}products/${window.styleFinderProduct}?view=fit-assistant`);
      data = JSON.parse(await response.text());
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }

    return data;
  }

  async getFittingSize(leftFootWidth, leftFootLength, rightFootWidth, rightFootLength, isAdult) {
    const fittingData = await this.fetchFittingData();
    const fittingSizes = isAdult ? fittingData.adults.sizes : fittingData.kids.sizes;

    const leftFootNarrowSize = fittingSizes.find((size) => leftFootLength >= size.narrow_fit.length_from && leftFootLength <= size.narrow_fit.length_to && leftFootWidth >= size.narrow_fit.width_from && leftFootWidth <= size.narrow_fit.width_to);
    const rightFootNarrowSize = fittingSizes.find((size) => rightFootLength >= size.narrow_fit.length_from && rightFootLength <= size.narrow_fit.length_to && rightFootWidth >= size.narrow_fit.width_from && rightFootWidth <= size.narrow_fit.width_to);
    if (leftFootNarrowSize && rightFootNarrowSize && leftFootNarrowSize.size === rightFootNarrowSize.size) {
      return { size: leftFootNarrowSize.size, fit: 'Narrow' };
    }

    const leftFootRegularSize = fittingSizes.find((size) => leftFootLength >= size.regular_fit.length_from && leftFootLength <= size.regular_fit.length_to && leftFootWidth >= size.regular_fit.width_from && leftFootWidth <= size.regular_fit.width_to);
    const rightFootRegularSize = fittingSizes.find((size) => rightFootLength >= size.regular_fit.length_from && rightFootLength <= size.regular_fit.length_to && rightFootWidth >= size.regular_fit.width_from && rightFootWidth <= size.regular_fit.width_to);
    if (leftFootRegularSize && rightFootRegularSize && leftFootRegularSize.size === rightFootRegularSize.size) {
      return { size: leftFootRegularSize.size, fit: 'Regular' };
    }

    return null;
  }

  openMeasuringTips() {
    this.fitAssistantContainer.style.display = 'none';
    this.measuringTipContainer.style.display = 'block';
  }

  playFittingVideo(event) {
    // eslint-disable-next-line no-undef, no-unused-vars
    const player = YT.get('player');

    if (player) {
      this.querySelector('#player').style.display = 'block';
      player.playVideo();
    } else {
      // eslint-disable-next-line no-undef, no-unused-vars
      const newPlayer = new YT.Player('player', {
        height: '100%',
        width: '100%',
        videoId: event.target.dataset.videoId,
        events: {
          onReady: (e) => e.target.playVideo(),
        },
      });
    }

    this.modalCloseButton.style.display = 'none';
    this.videoCloseButton.style.display = 'block';
  }

  closeFittingVideo() {
    // eslint-disable-next-line no-undef
    const player = YT.get('player');
    if (player) {
      player.stopVideo();
      this.querySelector('#player').style.display = 'none';
      this.modalCloseButton.style.display = 'block';
      this.videoCloseButton.style.display = 'none';
    }
  }

  closeMeasuringTips() {
    this.fitAssistantContainer.style.display = 'block';
    this.measuringTipContainer.style.display = 'none';
  }

  openFitAssistantDrawer(e) {
    if (e) e.preventDefault();
    document.body.classList.add('overflow-hidden');
    this.fitAssistantDrawer.classList.remove('visually-hidden');
    this.fitAssistantDrawer.classList.add('active');
  }

  closeFitAssistantDrawer() {
    document.body.classList.remove('overflow-hidden');
    this.fitAssistantDrawer.classList.remove('active');
  }
}

customElements.get('fit-assistant') || customElements.define('fit-assistant', FitAssistant); // eslint-disable-line

export default FitAssistant;
